import { render, staticRenderFns } from "./change-days.vue?vue&type=template&id=1546b6e3&"
import script from "./change-days.vue?vue&type=script&lang=js&"
export * from "./change-days.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports